
const reactTableWrapperStyle = {
  placeHolderWrapper: {
    textAlign: "center",
    fontSize: "20px",
    color: "#a7a7a7",
    padding: "35px"
  },
  placeHolderImg: {
    width: "142px",
    display: "block",
    margin: "auto",
    marginBottom: "20px"
  }
};

export default reactTableWrapperStyle;
